import React from 'react'
import Section from '../Section'
import ExperienceUnit from '../ExperienceUnit'

import jiraShotLogo from '../../assets/images/projects/jira_shot_logo.jpg'
import hungerMojiLogo from '../../assets/images/projects/hungermoji_logo_2.jpg'
import uwinBooksLogo from '../../assets/images/projects/uwin_books_logo.jpg'

class ProjectsSection extends React.Component {
  render() {
    return (
      <Section title="Projects">
        <div className="row">
          <ExperienceUnit
            logo={hungerMojiLogo}
            colour="#FFFFFF"
            title="HungerMoji"
            link="https://play.google.com/store/apps/details?id=com.mikeroelens.hungermoji"
            timeperiod="2016"
            subtitle={<span>A unique game that takes place in the Android notification drawer. Winner of Google's Android Experiments 2016.<br/><span className="bold">Tech:</span> Java, Android SDK</span>}
          />
          <ExperienceUnit
            logo={jiraShotLogo}
            colour="#302F2F"
            title="JiraShot"
            timeperiod="2015"
            subtitle={<span>JiraShot is a bug reporting tool for QA testers testing on Android. Edit and annotate bug screenshots and upload directly to Jira!<br/><span className="bold">Tech:</span> Java, Android SDK, OkHttp</span>}
          />
          <ExperienceUnit
            logo={uwinBooksLogo}
            colour="#FFFFFF"
            title="UWinBooks.com"
            link="https://uwinbooks.com"
            timeperiod="2014"
            subtitle={<span>Website that helped University of Windsor students find the textbooks they needed at the lowest possible price.<br/><span className="bold">Tech:</span> PHP, MySQL, jQuery, Nginx</span>}
          />
        </div>
      </Section>
    )
  }
}

export default ProjectsSection



// WEBPACK FOOTER //
// ./src/components/ProjectsSection/index.js